import 'react-app-polyfill/stable';
import { install } from 'resize-observer';
import 'url-search-params-polyfill';

// some browsers don't have ResizeObserver
if (!window.ResizeObserver) install();
